import styled, { css } from 'styled-components';

interface ClassificacaoParams {
	status: boolean;
}

export const ButtonGroup = styled.div<ClassificacaoParams>`
  display: flex;
	justify-content: flex-end;
  align-items: center;

  button {
    font-weight: 500;
  }

  .btn-desativar {
    border-top-left-radius: 7px;
    border-bottom-left-radius: 7px;
    border: 1px solid #b0bec5;
    border-right: 0;
    padding: 5px 10px;

    transition: 0.2s;

    &:hover {
      filter: brightness(0.9);
    }

    ${props =>
		!props.status &&
		css`
        background-color: #c53030;
        color: #fff;
        border: 0;
        :disabled {
          opacity: 1;
          cursor: not-allowed;
        }
      `}
  }

  .btn-ativar {
    border-top-right-radius: 7px;
    border-bottom-right-radius: 7px;
    border: 1px solid #b0bec5;
    border-left: 0;
    padding: 5px 10px;

    transition: 0.2s;

    &:hover {
      filter: brightness(0.9);
    }

    ${props =>
		props.status &&
		css`
        background-color: var(--azul-razio);
        color: #fff;
        border: 0;
        :disabled {
          opacity: 1;
          cursor: not-allowed;
        }
      `}
  }

	// 479px
  @media (max-width: 29.9375rem) {
		.btn-desativar {
			font-size: 12px;
			padding: 4px 8px;
		};
		.btn-ativar {
			font-size: 12px;
			padding: 4px 8px;
		}
  }
`;